import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "count"]
  static values = { liked: Boolean, likesCount: Number, postId: Number }

  toggle(event) {
    event.preventDefault()

    // Optimistic toggle
    this.likedValue = !this.likedValue
    this.likesCountValue += this.likedValue ? 1 : -1
    this._render()

    // Sync all instances of same post
    this._syncOthers()

    // Send to server
    const url = `/posts/${this.postIdValue}/like`
    const method = this.likedValue ? "POST" : "DELETE"
    const body = this.likedValue ? "kind=like" : ""

    fetch(url, {
      method,
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body
    })
  }

  _syncOthers() {
    const postId = this.postIdValue
    document.querySelectorAll(`[data-like-toggle-post-id-value="${postId}"]`).forEach(el => {
      if (el === this.element) return
      const ctrl = this.application.getControllerForElementAndIdentifier(el, "like-toggle")
      if (ctrl) {
        ctrl.likedValue = this.likedValue
        ctrl.likesCountValue = this.likesCountValue
        ctrl._render()
      }
    })
  }

  _render() {
    this.iconTarget.setAttribute("icon",
      this.likedValue ? "fluent:thumb-like-20-filled" : "fluent:thumb-like-20-regular"
    )

    this.element.classList.toggle("post__action--liked", this.likedValue)

    this.countTarget.textContent = this.likesCountValue > 0
      ? this._formatCount(this.likesCountValue)
      : ""
  }

  _formatCount(n) {
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace(".0", "") + " mi"
    if (n >= 1000) return (n / 1000).toFixed(1).replace(".0", "") + " mil"
    return n.toString()
  }
}
